import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../services/supabase/permission.service';

/**
 * Route guard factory: only activates if the JWT carries the given permission code.
 * If the user lacks the permission, redirects to `/` (which renders the
 * empty-permission landing state per decision #17).
 */
export function permissionGuard(code: string): CanActivateFn {
  return () => {
    const perms = inject(PermissionService);
    const router = inject(Router);
    if (perms.has(code)) {
      return true;
    }
    return router.createUrlTree(['/']);
  };
}

/**
 * Route guard factory: activates if the JWT carries ANY of the given permission
 * codes. Used by shell routes that aggregate multiple feature tabs (e.g. Team,
 * Practice Library) — the shell is reachable when at least one inner tab is.
 */
export function anyPermissionGuard(codes: readonly string[]): CanActivateFn {
  return () => {
    const perms = inject(PermissionService);
    const router = inject(Router);
    if (perms.hasAny(codes)) {
      return true;
    }
    return router.createUrlTree(['/']);
  };
}
